import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { fileUrl, priceLabel } from "../lib/api";

const ProductCard = ({ product, index = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, delay: (index % 3) * 0.12, ease: [0.16, 1, 0.3, 1] }}
    >
      <Link
        to={`/product/${product.id}`}
        data-testid={`product-card-${product.id}`}
        className="group block border border-white/10 bg-[#141414] hover:border-gold/40 transition-colors duration-500"
      >
        <div className="relative aspect-[3/4] overflow-hidden bg-[#0B0B0B]">
          {product.images?.[0] || product.thumbnail ? (
            <>
              <img
                src={fileUrl(product.thumbnail || product.images[0])}
                alt=""
                aria-hidden="true"
                className="absolute inset-0 w-full h-full object-cover scale-125 blur-2xl opacity-30 saturate-150"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-black/30 via-transparent to-black/40" />
              <img
                src={fileUrl(product.thumbnail || product.images[0])}
                alt={product.name}
                className="relative w-full h-full object-contain p-3 transition-transform duration-700 ease-out group-hover:scale-105"
              />
            </>
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-[#1F1F1F]">
              <span className="font-serif text-4xl text-zinc-700 italic">V</span>
            </div>
          )}
          {/* gold corner ticks */}
          <span className="absolute top-3 left-3 w-4 h-4 border-t border-l border-gold/60 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          <span className="absolute top-3 right-3 w-4 h-4 border-t border-r border-gold/60 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          <span className="absolute bottom-3 left-3 w-4 h-4 border-b border-l border-gold/60 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          <span className="absolute bottom-3 right-3 w-4 h-4 border-b border-r border-gold/60 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          {/* view piece reveal */}
          <div className="absolute bottom-0 inset-x-0 py-3 text-center bg-gradient-to-t from-black/75 to-transparent translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out">
            <span className="text-[10px] tracking-[0.35em] uppercase text-gold">View Piece</span>
          </div>
          {product.featured && (
            <span className="absolute top-4 left-4 text-[9px] tracking-[0.3em] uppercase bg-maroon text-[#F5F5F5] px-3 py-1 border border-gold/30">
              Featured
            </span>
          )}
        </div>
        <div className="p-6 group-hover:-translate-y-1 transition-transform duration-500">
          <p className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 truncate">{product.partner}</p>
          <div className="flex items-baseline justify-between mt-2 gap-4">
            <p className="font-serif text-xl text-[#F5F5F5] leading-tight">{product.name}</p>
            <p className="text-sm text-gold whitespace-nowrap">{priceLabel(product.price)}</p>
          </div>
          <p className="text-[10px] tracking-[0.25em] uppercase text-zinc-600 mt-2">{product.category}</p>
        </div>
      </Link>
    </motion.div>
  );
};

export default ProductCard;
